import { render, staticRenderFns } from "./LegacySslCertificateWizard.vue?vue&type=template&id=2d39570f&"
import script from "./LegacySslCertificateWizard.vue?vue&type=script&lang=js&"
export * from "./LegacySslCertificateWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports